export const COLORS = {
    CANDIDATES: {
        BAWUMIA: '#0047AB',
        KEN: '#FF0000',
        OWUSU: '#FFD700',
        ADDAI: '#800080',
        OTHERS: '#808080'
    },
    LEGEND: {
        LEVEL_1: '#b3cde0',
        LEVEL_2: '#6497b1',
        LEVEL_3: '#005b96',
        LEVEL_4: '#03396c',
        LEVEL_5: '#011f4b'
    },

    WINNER_LEGEND_COLORS_SHADES: {
        KEN: {
            COLOR: '#ff1a1a',
            COLOR_LOW: '#ff8080',
            COLOR_MEDIUM: '#ff4d4d',

        },
        BAWUMIA: {
            COLOR: '#0100e6',
            COLOR_LOW: '#7070f6ff',
            COLOR_MEDIUM: '#4e4dff',

        },
        OWUSU: {
            COLOR: '#ff1a1a',
            COLOR_LOW: '#ff6666',
            COLOR_MEDIUM: '#ff9999',
        },
        ADDAI: {
            COLOR: '#ff1a1a',
            COLOR_LOW: '#ff6666',
            COLOR_MEDIUM: '#ff9999',
        },
        OTHERS: {
            COLOR: '#ff1a1a',
            COLOR_LOW: '#ff6666',
            COLOR_MEDIUM: '#ff9999',
        },
    }
}
